// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Modern Gradebook Page */

.gradebookMain {
    min-height: calc(100vh - 70px);
    padding: 40px 60px;
    background: #ffffff;
    margin-top: 70px;
}

/* Header Section */
.gradebookHeader {
    margin-bottom: 32px;
}

.gradebookHeaderContent {
    display: flex;
    align-items: center;
    gap: 16px;
    margin-bottom: 20px;
}

.gradebookHeaderIcon {
    font-size: 32px !important;
    color: #667eea !important;
}

.gradebookTitle {
    font-size: 36px;
    font-weight: 700;
    color: #1f2937;
    margin: 0;
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
}

.gradebookAlert {
    background: rgba(102, 126, 234, 0.1) !important;
    border: 1px solid rgba(102, 126, 234, 0.2) !important;
    border-radius: 8px !important;
}

.gradebookAlert .ant-alert-message {
    color: #1f2937 !important;
    font-size: 14px;
}

/* Stats Grid */
.gradebookStatsGrid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 24px;
    margin-bottom: 40px;
}

/* Base Card Styles */
.gradebookCard {
    background: #ffffff !important;
    border: 1px solid rgba(102, 126, 234, 0.1) !important;
    border-radius: 16px !important;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05) !important;
    transition: all 0.3s ease !important;
}

.gradebookCard:hover {
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.1) !important;
    transform: translateY(-2px);
}

.gradebookCard .ant-card-body {
    padding: 24px !important;
}

/* Card Header */
.gradebookCardHeader {
    display: flex;
    align-items: center;
    gap: 12px;
    margin-bottom: 20px;
    padding-bottom: 16px;
    border-bottom: 1px solid rgba(0, 0, 0, 0.06);
}

.gradebookCardIconWrapper {
    width: 48px;
    height: 48px;
    border-radius: 12px;
    background: linear-gradient(135deg, rgba(102, 126, 234, 0.1) 0%, rgba(118, 75, 162, 0.1) 100%);
    border: 1px solid rgba(102, 126, 234, 0.2);
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
}

.gradebookCardIcon {
    font-size: 24px !important;
    color: #667eea !important;
}

.gradebookCardTitleWrapper {
    display: flex;
    align-items: center;
    gap: 8px;
    flex: 1 1;
}

.gradebookCardTitle {
    font-size: 18px;
    font-weight: 600;
    color: #1f2937;
    margin: 0;
}

.comingSoonBadge {
    opacity: 0.7;
}

/* Course Progress Card */
.courseProgressCardContent {
    display: flex;
    flex-direction: column;
    gap: 16px;
}

.courseProgressItem {
    display: flex;
    align-items: center;
    gap: 16px;
    padding: 12px;
    background: rgba(102, 126, 234, 0.02);
    border-radius: 12px;
    transition: all 0.3s ease;
}

.courseProgressItem:hover {
    background: rgba(102, 126, 234, 0.05);
    transform: translateX(4px);
}

.courseProgressItemIcon {
    width: 40px;
    height: 40px;
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
}

.courseProgressItemIcon.inProgress {
    background: rgba(102, 126, 234, 0.1);
    border: 1px solid rgba(102, 126, 234, 0.2);
}

.courseProgressItemIcon.inProgress svg {
    color: #667eea !important;
}

.courseProgressItemIcon.completed {
    background: rgba(16, 185, 129, 0.1);
    border: 1px solid rgba(16, 185, 129, 0.2);
}

.courseProgressItemIcon.completed svg {
    color: #10b981 !important;
}

.courseProgressItemIcon.incomplete {
    background: rgba(245, 87, 108, 0.1);
    border: 1px solid rgba(245, 87, 108, 0.2);
}

.courseProgressItemIcon.incomplete svg {
    color: #f5576c !important;
}

.courseProgressItemInfo {
    flex: 1 1;
}

.courseProgressItemLabel {
    font-size: 13px;
    color: #6b7280;
    margin: 0 0 4px 0;
    font-weight: 500;
    text-transform: uppercase;
    letter-spacing: 0.5px;
}

.courseProgressItemValue {
    font-size: 28px;
    font-weight: 700;
    color: #1f2937;
    margin: 0;
    line-height: 1;
}

/* Leaderboard Card */
.leaderboardCardContent {
    display: flex;
    flex-direction: column;
    gap: 16px;
}

.leaderboardStats {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 16px;
}

.leaderboardStatItem {
    text-align: center;
    padding: 16px;
    background: rgba(102, 126, 234, 0.02);
    border-radius: 12px;
}

.leaderboardStatLabel {
    font-size: 13px;
    color: #6b7280;
    margin: 0 0 8px 0;
    font-weight: 500;
    text-transform: uppercase;
    letter-spacing: 0.5px;
}

.leaderboardStatValue {
    font-size: 32px;
    font-weight: 700;
    color: #667eea;
    margin: 0;
    line-height: 1;
}

.leaderboardButton {
    color: #667eea !important;
    font-weight: 600 !important;
    padding: 0 !important;
    height: auto !important;
}

.leaderboardButton:hover {
    color: #764ba2 !important;
}

/* Timeline Card */
.timelineCardContent {
    display: flex;
    flex-direction: column;
    gap: 16px;
}

.timelineStatItem {
    padding: 16px;
    background: rgba(102, 126, 234, 0.02);
    border-radius: 12px;
}

.timelineStatLabel {
    font-size: 13px;
    color: #6b7280;
    margin: 0 0 8px 0;
    font-weight: 500;
    text-transform: uppercase;
    letter-spacing: 0.5px;
}

.timelineStatValue {
    font-size: 32px;
    font-weight: 700;
    color: #667eea;
    margin: 0;
    line-height: 1;
}

.timelineButton {
    color: #667eea !important;
    font-weight: 600 !important;
    padding: 0 !important;
    height: auto !important;
}

.timelineButton:hover:not(:disabled) {
    color: #764ba2 !important;
}

.timelineButton:disabled {
    color: #9ca3af !important;
    cursor: not-allowed;
}

/* Assessments Section */
.gradebookAssessments {
    margin-top: 40px;
}

.gradebookAssessmentsTitle {
    font-size: 24px;
    font-weight: 600;
    color: #1f2937;
    margin: 0 0 24px 0;
}

.gradebookCollapse {
    background: transparent !important;
}

.gradebookCollapse .ant-collapse-item {
    background: #ffffff !important;
    border: 1px solid rgba(102, 126, 234, 0.1) !important;
    border-radius: 12px !important;
    margin-bottom: 16px !important;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05) !important;
    transition: all 0.3s ease !important;
}

.gradebookCollapse .ant-collapse-item:hover {
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1) !important;
    border-color: rgba(102, 126, 234, 0.2) !important;
}

.gradebookCollapse .ant-collapse-header {
    padding: 20px 24px !important;
    border-radius: 12px !important;
}

.gradebookCollapse .ant-collapse-content {
    border-top: 1px solid rgba(0, 0, 0, 0.06) !important;
    border-radius: 0 0 12px 12px !important;
}

.gradebookCollapse .ant-collapse-content-box {
    padding: 24px !important;
}

.gradebookChartCard {
    background: rgba(102, 126, 234, 0.02) !important;
    border: 1px solid rgba(102, 126, 234, 0.1) !important;
    border-radius: 12px !important;
    max-width: 600px;
}

.gradebookChartCard .ant-card-body {
    padding: 24px !important;
}

.gradebookChartTitle {
    font-size: 20px;
    font-weight: 600;
    color: #1f2937;
    margin: 0 0 20px 0;
}

.gradebookCollapseIcon {
    color: #667eea !important;
    font-size: 16px !important;
}

.CollapseH1 {
    margin: 0 !important;
    color: #10b981 !important;
    font-size: 14px !important;
    font-weight: 600 !important;
    text-transform: uppercase;
    letter-spacing: 0.5px;
}

.gradebookCollapse .ant-collapse-header h4 {
    color: #1f2937 !important;
    font-size: 18px !important;
    font-weight: 600 !important;
    margin: 8px 0 0 0 !important;
}

.gradebookCollapse .ant-collapse-header .ant-collapse-header-text {
    width: 100%;
}

/* Modal */
.gradebookModal .ant-modal-content {
    border-radius: 16px !important;
}

.gradebookModal .ant-modal-header {
    border-radius: 16px 16px 0 0 !important;
    border-bottom: 1px solid rgba(0, 0, 0, 0.06) !important;
}

/* Legacy Styles (for compatibility) */
.GradeBook-main {
    display: none;
}

.GradeCard {
    display: none;
}

.marks-p {
    display: none;
}

.Collapse-Div {
    display: none;
}

.linkButton {
    display: none;
}

.custom-list {
    display: none;
}

/* Responsive Design */
@media (max-width: 1200px) {
    .gradebookMain {
        padding: 30px 40px;
    }

    .gradebookStatsGrid {
        grid-template-columns: repeat(2, 1fr);
    }
}

@media (max-width: 968px) {
    .gradebookMain {
        padding: 30px 20px;
    }

    .gradebookStatsGrid {
        grid-template-columns: 1fr;
    }

    .leaderboardStats {
        grid-template-columns: 1fr;
    }
}

@media (max-width: 768px) {
    .gradebookMain {
        padding: 20px 16px;
    }

    .gradebookTitle {
        font-size: 28px;
    }

    .gradebookCard .ant-card-body {
        padding: 20px !important;
    }

    .gradebookCardHeader {
        flex-direction: column;
        align-items: flex-start;
        gap: 12px;
    }

    .gradebookCardIconWrapper {
        width: 40px;
        height: 40px;
    }

    .gradebookCardIcon {
        font-size: 20px !important;
    }

    .gradebookCardTitle {
        font-size: 16px;
    }

    .courseProgressItemValue,
    .leaderboardStatValue,
    .timelineStatValue {
        font-size: 24px;
    }
}

@media (max-width: 480px) {
    .gradebookHeaderContent {
        flex-direction: column;
        align-items: flex-start;
    }

    .gradebookTitle {
        font-size: 24px;
    }

    .gradebookAssessmentsTitle {
        font-size: 20px;
    }
}
`, "",{"version":3,"sources":["webpack://./src/Components/Gradebook/GradeBook.css"],"names":[],"mappings":"AAAA,0BAA0B;;AAE1B;IACI,8BAA8B;IAC9B,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA,mBAAmB;AACnB;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,0BAA0B;IAC1B,yBAAyB;AAC7B;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,SAAS;IACT,6DAA6D;IAC7D,6BAA6B;IAC7B,oCAAoC;IACpC,qBAAqB;AACzB;;AAEA;IACI,+CAA+C;IAC/C,qDAAqD;IACrD,6BAA6B;AACjC;;AAEA;IACI,yBAAyB;IACzB,eAAe;AACnB;;AAEA,eAAe;AACf;IACI,aAAa;IACb,qCAAqC;IACrC,SAAS;IACT,mBAAmB;AACvB;;AAEA,qBAAqB;AACrB;IACI,8BAA8B;IAC9B,qDAAqD;IACrD,8BAA8B;IAC9B,qDAAqD;IACrD,oCAAoC;AACxC;;AAEA;IACI,oDAAoD;IACpD,2BAA2B;AAC/B;;AAEA;IACI,wBAAwB;AAC5B;;AAEA,gBAAgB;AAChB;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,mBAAmB;IACnB,oBAAoB;IACpB,4CAA4C;AAChD;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,8FAA8F;IAC9F,0CAA0C;IAC1C,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;AAClB;;AAEA;IACI,0BAA0B;IAC1B,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,SAAO;AACX;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,SAAS;AACb;;AAEA;IACI,YAAY;AAChB;;AAEA,yBAAyB;AACzB;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,aAAa;IACb,qCAAqC;IACrC,mBAAmB;IACnB,yBAAyB;AAC7B;;AAEA;IACI,qCAAqC;IACrC,0BAA0B;AAC9B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;AAClB;;AAEA;IACI,oCAAoC;IACpC,0CAA0C;AAC9C;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,mCAAmC;IACnC,yCAAyC;AAC7C;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,mCAAmC;IACnC,yCAAyC;AAC7C;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,SAAO;AACX;;AAEA;IACI,eAAe;IACf,cAAc;IACd,iBAAiB;IACjB,gBAAgB;IAChB,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,SAAS;IACT,cAAc;AAClB;;AAEA,qBAAqB;AACrB;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,SAAS;AACb;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,qCAAqC;IACrC,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,iBAAiB;IACjB,gBAAgB;IAChB,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,SAAS;IACT,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,2BAA2B;IAC3B,qBAAqB;IACrB,uBAAuB;AAC3B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA,kBAAkB;AAClB;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,qCAAqC;IACrC,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,iBAAiB;IACjB,gBAAgB;IAChB,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,SAAS;IACT,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,2BAA2B;IAC3B,qBAAqB;IACrB,uBAAuB;AAC3B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA,wBAAwB;AACxB;IACI,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,8BAA8B;IAC9B,qDAAqD;IACrD,8BAA8B;IAC9B,8BAA8B;IAC9B,oDAAoD;IACpD,oCAAoC;AACxC;;AAEA;IACI,oDAAoD;IACpD,iDAAiD;AACrD;;AAEA;IACI,6BAA6B;IAC7B,8BAA8B;AAClC;;AAEA;IACI,oDAAoD;IACpD,uCAAuC;AAC3C;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,gDAAgD;IAChD,qDAAqD;IACrD,8BAA8B;IAC9B,gBAAgB;AACpB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;IACzB,0BAA0B;AAC9B;;AAEA;IACI,oBAAoB;IACpB,yBAAyB;IACzB,0BAA0B;IAC1B,2BAA2B;IAC3B,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,yBAAyB;IACzB,0BAA0B;IAC1B,2BAA2B;IAC3B,4BAA4B;AAChC;;AAEA;IACI,WAAW;AACf;;AAEA,UAAU;AACV;IACI,8BAA8B;AAClC;;AAEA;IACI,uCAAuC;IACvC,uDAAuD;AAC3D;;AAEA,sCAAsC;AACtC;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA,sBAAsB;AACtB;IACI;QACI,kBAAkB;IACtB;;IAEA;QACI,qCAAqC;IACzC;AACJ;;AAEA;IACI;QACI,kBAAkB;IACtB;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;QACI,0BAA0B;IAC9B;AACJ;;AAEA;IACI;QACI,kBAAkB;IACtB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,wBAAwB;IAC5B;;IAEA;QACI,sBAAsB;QACtB,uBAAuB;QACvB,SAAS;IACb;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;QACI,eAAe;IACnB;;IAEA;;;QAGI,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,sBAAsB;QACtB,uBAAuB;IAC3B;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;AACJ","sourcesContent":["/* Modern Gradebook Page */\n\n.gradebookMain {\n    min-height: calc(100vh - 70px);\n    padding: 40px 60px;\n    background: #ffffff;\n    margin-top: 70px;\n}\n\n/* Header Section */\n.gradebookHeader {\n    margin-bottom: 32px;\n}\n\n.gradebookHeaderContent {\n    display: flex;\n    align-items: center;\n    gap: 16px;\n    margin-bottom: 20px;\n}\n\n.gradebookHeaderIcon {\n    font-size: 32px !important;\n    color: #667eea !important;\n}\n\n.gradebookTitle {\n    font-size: 36px;\n    font-weight: 700;\n    color: #1f2937;\n    margin: 0;\n    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n    -webkit-background-clip: text;\n    -webkit-text-fill-color: transparent;\n    background-clip: text;\n}\n\n.gradebookAlert {\n    background: rgba(102, 126, 234, 0.1) !important;\n    border: 1px solid rgba(102, 126, 234, 0.2) !important;\n    border-radius: 8px !important;\n}\n\n.gradebookAlert .ant-alert-message {\n    color: #1f2937 !important;\n    font-size: 14px;\n}\n\n/* Stats Grid */\n.gradebookStatsGrid {\n    display: grid;\n    grid-template-columns: repeat(3, 1fr);\n    gap: 24px;\n    margin-bottom: 40px;\n}\n\n/* Base Card Styles */\n.gradebookCard {\n    background: #ffffff !important;\n    border: 1px solid rgba(102, 126, 234, 0.1) !important;\n    border-radius: 16px !important;\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05) !important;\n    transition: all 0.3s ease !important;\n}\n\n.gradebookCard:hover {\n    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.1) !important;\n    transform: translateY(-2px);\n}\n\n.gradebookCard .ant-card-body {\n    padding: 24px !important;\n}\n\n/* Card Header */\n.gradebookCardHeader {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    margin-bottom: 20px;\n    padding-bottom: 16px;\n    border-bottom: 1px solid rgba(0, 0, 0, 0.06);\n}\n\n.gradebookCardIconWrapper {\n    width: 48px;\n    height: 48px;\n    border-radius: 12px;\n    background: linear-gradient(135deg, rgba(102, 126, 234, 0.1) 0%, rgba(118, 75, 162, 0.1) 100%);\n    border: 1px solid rgba(102, 126, 234, 0.2);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    flex-shrink: 0;\n}\n\n.gradebookCardIcon {\n    font-size: 24px !important;\n    color: #667eea !important;\n}\n\n.gradebookCardTitleWrapper {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    flex: 1;\n}\n\n.gradebookCardTitle {\n    font-size: 18px;\n    font-weight: 600;\n    color: #1f2937;\n    margin: 0;\n}\n\n.comingSoonBadge {\n    opacity: 0.7;\n}\n\n/* Course Progress Card */\n.courseProgressCardContent {\n    display: flex;\n    flex-direction: column;\n    gap: 16px;\n}\n\n.courseProgressItem {\n    display: flex;\n    align-items: center;\n    gap: 16px;\n    padding: 12px;\n    background: rgba(102, 126, 234, 0.02);\n    border-radius: 12px;\n    transition: all 0.3s ease;\n}\n\n.courseProgressItem:hover {\n    background: rgba(102, 126, 234, 0.05);\n    transform: translateX(4px);\n}\n\n.courseProgressItemIcon {\n    width: 40px;\n    height: 40px;\n    border-radius: 10px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    flex-shrink: 0;\n}\n\n.courseProgressItemIcon.inProgress {\n    background: rgba(102, 126, 234, 0.1);\n    border: 1px solid rgba(102, 126, 234, 0.2);\n}\n\n.courseProgressItemIcon.inProgress svg {\n    color: #667eea !important;\n}\n\n.courseProgressItemIcon.completed {\n    background: rgba(16, 185, 129, 0.1);\n    border: 1px solid rgba(16, 185, 129, 0.2);\n}\n\n.courseProgressItemIcon.completed svg {\n    color: #10b981 !important;\n}\n\n.courseProgressItemIcon.incomplete {\n    background: rgba(245, 87, 108, 0.1);\n    border: 1px solid rgba(245, 87, 108, 0.2);\n}\n\n.courseProgressItemIcon.incomplete svg {\n    color: #f5576c !important;\n}\n\n.courseProgressItemInfo {\n    flex: 1;\n}\n\n.courseProgressItemLabel {\n    font-size: 13px;\n    color: #6b7280;\n    margin: 0 0 4px 0;\n    font-weight: 500;\n    text-transform: uppercase;\n    letter-spacing: 0.5px;\n}\n\n.courseProgressItemValue {\n    font-size: 28px;\n    font-weight: 700;\n    color: #1f2937;\n    margin: 0;\n    line-height: 1;\n}\n\n/* Leaderboard Card */\n.leaderboardCardContent {\n    display: flex;\n    flex-direction: column;\n    gap: 16px;\n}\n\n.leaderboardStats {\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n    gap: 16px;\n}\n\n.leaderboardStatItem {\n    text-align: center;\n    padding: 16px;\n    background: rgba(102, 126, 234, 0.02);\n    border-radius: 12px;\n}\n\n.leaderboardStatLabel {\n    font-size: 13px;\n    color: #6b7280;\n    margin: 0 0 8px 0;\n    font-weight: 500;\n    text-transform: uppercase;\n    letter-spacing: 0.5px;\n}\n\n.leaderboardStatValue {\n    font-size: 32px;\n    font-weight: 700;\n    color: #667eea;\n    margin: 0;\n    line-height: 1;\n}\n\n.leaderboardButton {\n    color: #667eea !important;\n    font-weight: 600 !important;\n    padding: 0 !important;\n    height: auto !important;\n}\n\n.leaderboardButton:hover {\n    color: #764ba2 !important;\n}\n\n/* Timeline Card */\n.timelineCardContent {\n    display: flex;\n    flex-direction: column;\n    gap: 16px;\n}\n\n.timelineStatItem {\n    padding: 16px;\n    background: rgba(102, 126, 234, 0.02);\n    border-radius: 12px;\n}\n\n.timelineStatLabel {\n    font-size: 13px;\n    color: #6b7280;\n    margin: 0 0 8px 0;\n    font-weight: 500;\n    text-transform: uppercase;\n    letter-spacing: 0.5px;\n}\n\n.timelineStatValue {\n    font-size: 32px;\n    font-weight: 700;\n    color: #667eea;\n    margin: 0;\n    line-height: 1;\n}\n\n.timelineButton {\n    color: #667eea !important;\n    font-weight: 600 !important;\n    padding: 0 !important;\n    height: auto !important;\n}\n\n.timelineButton:hover:not(:disabled) {\n    color: #764ba2 !important;\n}\n\n.timelineButton:disabled {\n    color: #9ca3af !important;\n    cursor: not-allowed;\n}\n\n/* Assessments Section */\n.gradebookAssessments {\n    margin-top: 40px;\n}\n\n.gradebookAssessmentsTitle {\n    font-size: 24px;\n    font-weight: 600;\n    color: #1f2937;\n    margin: 0 0 24px 0;\n}\n\n.gradebookCollapse {\n    background: transparent !important;\n}\n\n.gradebookCollapse .ant-collapse-item {\n    background: #ffffff !important;\n    border: 1px solid rgba(102, 126, 234, 0.1) !important;\n    border-radius: 12px !important;\n    margin-bottom: 16px !important;\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05) !important;\n    transition: all 0.3s ease !important;\n}\n\n.gradebookCollapse .ant-collapse-item:hover {\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1) !important;\n    border-color: rgba(102, 126, 234, 0.2) !important;\n}\n\n.gradebookCollapse .ant-collapse-header {\n    padding: 20px 24px !important;\n    border-radius: 12px !important;\n}\n\n.gradebookCollapse .ant-collapse-content {\n    border-top: 1px solid rgba(0, 0, 0, 0.06) !important;\n    border-radius: 0 0 12px 12px !important;\n}\n\n.gradebookCollapse .ant-collapse-content-box {\n    padding: 24px !important;\n}\n\n.gradebookChartCard {\n    background: rgba(102, 126, 234, 0.02) !important;\n    border: 1px solid rgba(102, 126, 234, 0.1) !important;\n    border-radius: 12px !important;\n    max-width: 600px;\n}\n\n.gradebookChartCard .ant-card-body {\n    padding: 24px !important;\n}\n\n.gradebookChartTitle {\n    font-size: 20px;\n    font-weight: 600;\n    color: #1f2937;\n    margin: 0 0 20px 0;\n}\n\n.gradebookCollapseIcon {\n    color: #667eea !important;\n    font-size: 16px !important;\n}\n\n.CollapseH1 {\n    margin: 0 !important;\n    color: #10b981 !important;\n    font-size: 14px !important;\n    font-weight: 600 !important;\n    text-transform: uppercase;\n    letter-spacing: 0.5px;\n}\n\n.gradebookCollapse .ant-collapse-header h4 {\n    color: #1f2937 !important;\n    font-size: 18px !important;\n    font-weight: 600 !important;\n    margin: 8px 0 0 0 !important;\n}\n\n.gradebookCollapse .ant-collapse-header .ant-collapse-header-text {\n    width: 100%;\n}\n\n/* Modal */\n.gradebookModal .ant-modal-content {\n    border-radius: 16px !important;\n}\n\n.gradebookModal .ant-modal-header {\n    border-radius: 16px 16px 0 0 !important;\n    border-bottom: 1px solid rgba(0, 0, 0, 0.06) !important;\n}\n\n/* Legacy Styles (for compatibility) */\n.GradeBook-main {\n    display: none;\n}\n\n.GradeCard {\n    display: none;\n}\n\n.marks-p {\n    display: none;\n}\n\n.Collapse-Div {\n    display: none;\n}\n\n.linkButton {\n    display: none;\n}\n\n.custom-list {\n    display: none;\n}\n\n/* Responsive Design */\n@media (max-width: 1200px) {\n    .gradebookMain {\n        padding: 30px 40px;\n    }\n\n    .gradebookStatsGrid {\n        grid-template-columns: repeat(2, 1fr);\n    }\n}\n\n@media (max-width: 968px) {\n    .gradebookMain {\n        padding: 30px 20px;\n    }\n\n    .gradebookStatsGrid {\n        grid-template-columns: 1fr;\n    }\n\n    .leaderboardStats {\n        grid-template-columns: 1fr;\n    }\n}\n\n@media (max-width: 768px) {\n    .gradebookMain {\n        padding: 20px 16px;\n    }\n\n    .gradebookTitle {\n        font-size: 28px;\n    }\n\n    .gradebookCard .ant-card-body {\n        padding: 20px !important;\n    }\n\n    .gradebookCardHeader {\n        flex-direction: column;\n        align-items: flex-start;\n        gap: 12px;\n    }\n\n    .gradebookCardIconWrapper {\n        width: 40px;\n        height: 40px;\n    }\n\n    .gradebookCardIcon {\n        font-size: 20px !important;\n    }\n\n    .gradebookCardTitle {\n        font-size: 16px;\n    }\n\n    .courseProgressItemValue,\n    .leaderboardStatValue,\n    .timelineStatValue {\n        font-size: 24px;\n    }\n}\n\n@media (max-width: 480px) {\n    .gradebookHeaderContent {\n        flex-direction: column;\n        align-items: flex-start;\n    }\n\n    .gradebookTitle {\n        font-size: 24px;\n    }\n\n    .gradebookAssessmentsTitle {\n        font-size: 20px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
